import React, { useState } from 'react'
import { Button } from 'react-bootstrap'
import classNames from 'classnames'
import SinglePlanModal from './SinglePlanModal'

import { ReactComponent as GoldAccountIcon } from '../../../assets/svg/icons/plan-icon.svg'

import '../../../assets/sass/components/plans/plan-button.scss'

const PlanButton = ({
    className,
    plan = "gold",
    text = 'Gold Account',
    children,
    ...props
}) => {
    const [showModal, setShowModal] = useState(false);

    return (
        <>
            <Button
                variant=""
                className={classNames("plan-button", plan, className)}
                onClick={() => setShowModal(true)}
                {...props}
            >
                <GoldAccountIcon className="icon" />
                <span className="text">{children || text}</span>
            </Button>
            <SinglePlanModal
                size="md-sm"
                plan={plan}
                show={showModal}
                onHide={() => setShowModal(false)}
            />
        </>
    )
}

export default PlanButton
